import React from 'react';
import { Icon, ICON_SIZE, Icons } from '../../Icons';
import { MultiInput, TextInput } from '../../Input';
import { Spinner } from '../../Spinner';
import { BaseSelectTriggerProps } from './BaseSelect.types';

const BaseSelectTrigger = ({
  disabled,
  isOpen,
  selectedOptions,
  size,
  handleOptionSelection,
  setIsOpen,
  clearable,
  customButton,
  error,
  loading,
  multiSelect,
  placeholder,
  width,
  wrap,
}: BaseSelectTriggerProps) => {
  const renderEndElement = () => {
    const showClearButton = clearable && !disabled && !multiSelect && !!selectedOptions.length;
    return (
      <div className="flex items-center gap-2">
        {/* Optional clear button to clear all selected options. */}
        {showClearButton && (
          <Icons
            color="text-gray-800"
            tooltip="Clear"
            icon={Icon.CLOSE}
            size={size}
            onClick={() => handleOptionSelection(undefined)}
          />
        )}
        {/* Toggle button to open/close the dropdown. */}
        {loading && <Spinner size={ICON_SIZE[size]} />}
        {!loading && (
          <Icons
            color="text-gray-800"
            icon={isOpen ? Icon.CHEVRON_UP : Icon.CHEVRON_DOWN}
            size={size}
            onClick={() => setIsOpen((prev) => !prev)}
            disabled={disabled}
          />
        )}
      </div>
    );
  };

  return (
    <>
      {!customButton && !multiSelect && (
        <TextInput
          placeholder={placeholder}
          value={selectedOptions[0]?.label}
          size={size}
          endElement={renderEndElement()}
          disabled={disabled}
          focused={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
          error={!!error}
          width={width}
        />
      )}
      {!customButton && multiSelect && (
        <MultiInput
          placeholder={placeholder}
          size={size}
          value={selectedOptions.map((option) => ({
            color: option.color,
            label: option.label,
            onDelete: () => handleOptionSelection(option.value),
          }))}
          endElement={renderEndElement()}
          disabled={disabled}
          focused={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
          error={!!error}
          width={width}
          wrap={wrap}
        />
      )}
      {customButton &&
        React.cloneElement(customButton, {
          active: isOpen,
          onClick: () => setIsOpen((prev) => !prev),
        })}
    </>
  );
};

export default BaseSelectTrigger;
